import React, { Component } from 'react';
import DrawableCanvas from 'react-drawable-canvas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateModal } from '../../actions/modal.js';
import { clearDraw } from '../../actions/ts_overlay_actions.js';
import { changeMap } from '../../actions/ts_map_actions.js';
import { updateCanvas } from '../../actions/ts_canvas_actions.js';
import { setActive } from '../../actions/ts_active_actions.js';
import { Button, Grid, Row, Col, Clearfix, Thumbnail } from 'react-bootstrap';
import Menu from '../menu/';
import StratDetails from '../stratDetails/';
import logger from '../../actions/log.js';
import utils from '../../utils/config.js';
import {getGameTitle, getMapTitle} from '../../utils/maps/titleUtil.js';
import {
  welcome,
  blooddrive,impact,dam,reclaimed,lift,harbor,foundation,diner,forge,theslab,oldtown,
  inferno,train,mirage,nuke,cobblestone,overpass,cache,
  promenade,redfalls,reactor,station,trench,vertigo,grandview,mammoth,
  soccer, football, basketball, baseball, hockey,
  bank1, bank2, bank3, bank4, clubhouse1, clubhouse2, clubhouse3, clubhouse4,
  asylum,bunker,district,exhibit,icebound,traininggrounds,vasgar,
  bind, haven, split, ascent,
  canals, favelas, skyfell, windward, icarus, vice, highcastle, factory
  
} from '../../utils/maps/image_paths.jsx';
import PlaybookIcon from '../../images/trickstrat/playbook.png';
import Icon from '../../images/trickstrat/ts_icon.png';
import PlaybookSketch from '../../images/trickstrat/playbookSketch.png';
import StratDelete from '../stratDelete/';

var loginButtons={
  borderRadius: '0%',
  marginTop:'25',
  width: '100%',
  color:'lightblue',
  letterSpacing:'2',
  fontSize:'1.2em',
  fontWeight:'100',
  background: 'transparent',
  border: '0px solid white',
  cursor:'pointer',
}

class Playbook extends Component {

  changeMap(game,map)
  {
    var {overlay} = this.props;
    this.props.changeMap(game,map);
    logger.logMapClick(game,map);
    this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
    this.props.updateModal(false,null);
    this.props.updateCanvas(null,null,[]);
  }

openStrat(strat, stratId){
  this.props.setActive(strat, stratId);
  this.changeMap(strat.game,strat.map);
}

  playbookLogic(strat, stratId) {
    var data = {
      TRICKSTRATWELCOME: welcome,
      GEARS4IMPACT: impact,GEARS4BLOODDRIVE: blooddrive,GEARS4DAM: dam,GEARS4RECLAIMED: reclaimed,GEARS4LIFT: lift,GEARS4HARBOR: harbor,GEARS4FOUNDATION: foundation,GEARS4DINER: diner,GEARS4FORGE: forge,GEARS4THESLAB: theslab,GEARS4OLDTOWN: oldtown,
      CSGOINFERNO: inferno,CSGOTRAIN: train,CSGOMIRAGE: mirage,CSGONUKE: nuke,CSGOCOBBLESTONE: cobblestone,CSGOOVERPASS: overpass,CSGOCACHE: cache,
      LAWBREAKERSPROMENADE: promenade, LAWBREAKERSREDFALLS: redfalls, LAWBREAKERSREACTOR: reactor, LAWBREAKERSSTATION: station, LAWBREAKERSTRENCH: trench, LAWBREAKERSVERTIGO: vertigo, LAWBREAKERSGRANDVIEW: grandview, LAWBREAKERSMAMMOTH: mammoth,
      SPORTSSOCCER: soccer,SPORTSFOOTBALL: football,SPORTSBASKETBALL: basketball,SPORTSBASEBALL: baseball,SPORTSHOCKEY: hockey,
      RS6BANK1: bank1, RS6BANK2: bank2, RS6BANK3: bank3, RS6BANK4: bank4,
      RS6CLUBHOUSE1: clubhouse1, RS6CLUBHOUSE2: clubhouse2, RS6CLUBHOUSE3: clubhouse3, RS6CLUBHOUSE4: clubhouse4,
      GEARS5ASYLUM: asylum, GEARS5BUNKER: bunker, GEARS5DAM: dam, GEARS5DISTRICT: district, GEARS5EXHIBIT: exhibit, GEARS5FORGE: forge,GEARS5FOUNDATION: foundation,GEARS5HARBOR: harbor, GEARS5TRAININGGROUNDS: traininggrounds,GEARS5ICEBOUND: icebound,GEARS5RECLAIMED: reclaimed, GEARS5VASGAR: vasgar,
      VALORANTBIND: bind, VALORANTHAVEN: haven, VALORANTSPLIT: split, VALORANTASCENT: ascent,
      ROGUECOMPANYCANALS: canals, ROGUECOMPANYFAVELAS: favelas, ROGUECOMPANYSKYFELL: skyfell, ROGUECOMPANYWINDWARD: windward, ROGUECOMPANYICARUS: icarus, ROGUECOMPANYVICE: vice, ROGUECOMPANYHIGHCASTLE: highcastle, ROGUECOMPANYFACTORY: factory
    };
    var stratImg = data[strat.game.toUpperCase()+strat.map.toUpperCase()];
    if (stratImg == undefined)
    {
      stratImg = PlaybookSketch;
    }
          var stratDisplay = <Col xs={4} md={4}>

                <Thumbnail onClick={(event) => {this.openStrat(strat, stratId);}} bsClass="thumbnail" src={stratImg} alt="">
                    <span className="thumbnailText"><b>{strat.name}</b></span><br/><span className="thumbnailText dim"><b>{getMapTitle(strat.map)}</b></span><br/>
               </Thumbnail>
                 <span className="thumbnail"><button className="lightblue buttonStyle thumbnailText" onClick={(event) => {this.props.updateModal(true,<StratDetails strat={strat} id={stratId}/>);}}><i className="fa fa-sticky-note-o fa-fw"></i></button>
                 <button className="lightblue buttonStyle thumbnailText"  onClick={(event) => {this.props.updateModal(true,<StratDelete strat={strat} id={stratId}/>);}}><b>X</b></button>
                 </span>
              </Col>
            return stratDisplay;
        }


    addNewLogic(stratCount) {
      if(stratCount >= 9){return};
          var addNewDisplay = null;
                addNewDisplay =
                <Col xs={4} md={4}>
                  <Thumbnail bsClass="thumbnail" src={PlaybookIcon} alt="thumbnail" onClick={(event) => {this.props.updateModal(true,<Menu/>);}}>
                 </Thumbnail>

                 </Col>
              return addNewDisplay;
      }

  constructor(props) {
      super(props);
  }

    render() {
      var strats = 0;
      var {currentUser, userData} = this.props;
      if (userData.data != null && userData.data != undefined) {
        if (userData.data.strats != null && userData.data.strats != undefined)
        {
        strats = userData.data.strats;
        }
      }
        var stratCount = Object.keys(strats).length;
        var tsIcon =  <span><img width="75" height="78" src={Icon}></img></span>
        var pbIcon =  <span><img width="50" src={PlaybookIcon}></img></span>
        return (
          <div>
                    <span className="menuHeaderText">{tsIcon} Esports Playbook <span className="dim">{stratCount}/9</span></span><br/>
                          <Row id="divThumbnailBox">
                    {Object.keys(strats).map(item => {return this.playbookLogic(strats[item], item)})}

                    {this.addNewLogic(stratCount)}
                  </Row>
          </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateModal,
        setActive,
        changeMap,
        updateModal,
        updateCanvas,
        clearDraw
    }, dispatch);
}

function mapStateToProps(state) {
    return { map: state.map, overlay: state.overlay, currentUser:state.currentUser, canvas : state.canvas, userData: state.userData };
}

export default connect(mapStateToProps, mapDispatchToProps)(Playbook);



// WEBPACK FOOTER //
// ./src/app/components/playbook/index.jsx